import { api } from '@/api';
import { ApiResponseType, GetMePartner, GetMePlayer } from '@/api/type';

/** 로그인 사용자 정보 */
export const getMe = async () => {
  try {
    const res =
      await api.get<ApiResponseType<GetMePlayer | GetMePartner>>(
        `/api/web/visitors/me`
      );
    return res.data;
  } catch (err) {
    throw err;
  }
};
